import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/styles'
import {
  SortingState, SelectionState, FilteringState, GroupingState,
  IntegratedFiltering, IntegratedGrouping, IntegratedSelection,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  Table, TableHeaderRow, TableFilterRow, TableGroupRow,
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class TechSpecGrid extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "category", title: "Kategorie" },
        { name: "feature", title: "Feature" },
        { name: "property", title: "Eigenschaft" }
      ],
      rows: [
        { category: 'Kategorie', feature: 'Kamera Modell', property: 'INSTAR IN-3011 S&N Innen - Farbe / IR' },
        { category: 'Kategorie', feature: 'Gehäuse', property: 'ABS (Weiß, Schwarz)' },
        { category: 'Kategorie', feature: 'Bildsensor', property: 'OV7740 VGA 1/5" CMOS' },
        { category: 'Kategorie', feature: 'Unterstützte Auflösungen	', property: '640x480, 320x240, 160x120' },
        { category: 'Kategorie', feature: 'Video Kompression', property: 'MJPEG, JPG' },
        { category: 'Kategorie', feature: 'Framerate', property: 'bis zu 30fps' },
        { category: 'Kategorie', feature: 'Sensor Sensibilität', property: '6800 mV/lux*s' },
        { category: 'Kategorie', feature: 'Dynamikbereich', property: '60 dB' },
        { category: 'Kategorie', feature: 'Signal/Geräusch', property: '41 dB' },
        { category: 'Kategorie', feature: 'Tag / Nacht Wechsel', property: 'Ja' },
        { category: 'Kategorie', feature: 'Min. Beleuchtung (Farbe)', property: '0.05 Lux @ f/2.0' },
        { category: 'Kategorie', feature: 'Min. Beleuchtung (IR)', property: '0.5 lux @ f/2.0' },
        { category: 'Kategorie', feature: '# von parallelen Streams', property: '3' },
        { category: 'Kategorie', feature: 'Weißabgleich', property: 'Automatisch' },
        { category: 'Kategorie', feature: 'Elektronische Blende', property: 'Automatisch' },
        { category: 'Kategorie', feature: 'Video Drehen / Spiegeln', property: 'Ja / Ja' },
        { category: 'Kategorie', feature: 'Oberfläche Video', property: 'Datum, Zeit, Kameraname' },
        { category: 'Kategorie', feature: 'Video Parameter', property: 'Helligkeit, Kontrast' },
        { category: 'Kategorie', feature: 'Linse', property: '6 mm (Manueller Fokus) f/2.0' },
        { category: 'Kategorie', feature: 'Blickwinkel', property: '37° Horizontal' },
        { category: 'Kategorie', feature: 'Infrarot LEDs', property: '10 @ 850 nm Switchable' },
        { category: 'Kategorie', feature: 'Effektive Reichweite (IR)', property: '8 - 12 m' },
        { category: 'Kategorie', feature: 'intgr. IRcut Filter', property: 'Nein' },
        { category: 'Kategorie', feature: 'Optischer Zoom', property: 'Nein' },
        { category: 'Kategorie', feature: 'Digitaler Zoom', property: 'Nein' },
        { category: 'Kategorie', feature: 'Audio', property: 'Integrierter Lautsprecher und Audio-out (3.5mm Headphone Jack)' },
        { category: 'Kategorie', feature: 'Mikrofon', property: 'Integriert' },
        { category: 'Kategorie', feature: 'Alarm I/O', property: 'Ja (potential-free alarm-out / max. 60VDC/125VAC @ 1A)' },
        { category: 'Kategorie', feature: 'Alarm Benachrichtigung', property: 'Email/FTP/HTTP/Alarm-Out' },
        { category: 'Kategorie', feature: 'Unterstützte Browser', property: 'Chrome, Safari, Firefox, Internet Explorer' },
        { category: 'Kategorie', feature: 'Unterstützte Windows Software', property: 'InstarVision, Sighthound, WebcamXP, iSpy, VLC Player, etc.' },
        { category: 'Kategorie', feature: 'Unterstützte MacOSX Software', property: 'Sighthound, SecuritySpy, VLC Player, etc.' },
        { category: 'Kategorie', feature: 'Unterstützte Android Apps', property: 'InstarVision, IP Cam Viewer, Tiny Cam Monitor etc.' },
        { category: 'Kategorie', feature: 'Unterstützte iOS Apps', property: 'InstarVision, LiveCams' },
        { category: 'Kategorie', feature: 'Unterstützte Windows Phone Apps', property: 'InstarVision' },
        { category: 'Kategorie', feature: 'Netzwerk Schnittstelle', property: '10Base-T/100Base-TX Ethernet Port / WLAN IEEE 802.11b/g (nicht bei PoE Version) / PoE IEEE 802.3af (nicht bei WiFi Version)' },
        { category: 'Kategorie', feature: 'Netzwerk Protokolle', property: 'TCP/IP, DHCP, PPPoE, ARP, FTP, SMTP, DNS, NTP, UPnP, HTTP, TCP, UDP' },
        { category: 'Kategorie', feature: 'Verschlüsselung', property: 'WEP (64/128bit), WPA/WPA2-PSK (TKIP, AES, CCMP)' },
        { category: 'Kategorie', feature: 'Wifi Frequenzen', property: '2.4GHz 802.11b/g (nicht bei PoE Version)' },
        { category: 'Kategorie', feature: 'Wifi Antenne', property: '5 dBi WLAN RP-SMA Antenna (nicht bei PoE Version)' },
        { category: 'Kategorie', feature: 'Zugangsbeschränkung', property: 'Username/Password - 3 Level Authentifizierung' },
        { category: 'Kategorie', feature: 'Netzteil', property: '110-240V ac @ 50-60Hz to 5V dc and 2000mA' },
        { category: 'Kategorie', feature: 'Netzstecker', property: '1.35mm In / 3.5mm Out' },
        { category: 'Kategorie', feature: 'Stromverbrauch', property: 'Max. 7.6 W' },
        { category: 'Kategorie', feature: 'Integr. DDNS Service', property: 'Ja' },
        { category: 'Kategorie', feature: 'Schwenken & Neigen', property: '280° / 120°' },
        { category: 'Kategorie', feature: 'Maßangaben in [cm]', property: '12.1 / 9.5 / 10.9' },
        { category: 'Kategorie', feature: 'Gewicht', property: '245 g' },
        { category: 'Kategorie', feature: 'Temperatur', property: '-5°C - 55°C' },
        { category: 'Kategorie', feature: 'Zertifizierungen', property: 'CE, FCC, RoHS' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns} >

          <FilteringState />

          <SortingState
            defaultSorting={[
              { columnName: 'category', direction: 'asc' },
            ]}
          />
          <GroupingState
            defaultGrouping={[{ columnName: 'category' }]}
            defaultExpandedGroups={['Categories']}
          />
          <SelectionState />

          <IntegratedFiltering />
          <IntegratedGrouping />
          <IntegratedSelection />
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
          <TableFilterRow />
          <TableGroupRow />
        </Grid>
      </Paper>
    );
  }
}

TechSpecGrid.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(TechSpecGrid)